"use strict";
////////////////////////////////////////////////////////////////////////////////
// 命名空间："art"通用函数封装
var tmi = {};
export default tmi;

//##############################################################################
// [交易合约]
// 检查是否是合约品种（商品）。
tmi.isProduct = function (productId) {
    for (var i = 0; i < productId.length; ++i) {
        if (productId[i] <= '9' && productId[i] >= '0') {
            return false;
        }
    }
    return true;
};

////////////////////////////////////////////////////////////////////////////////
// 检查是否是合约品种（商品）。
tmi.productId = function (targetId) {
    for (var i = 0; i < targetId.length; ++i) {
        if (targetId[i] <= '9' && targetId[i] >= '0') {
            return targetId.substr(0, i);
        }
    }
    return "";
};


// WEBPACK FOOTER //
// ./static/js/proto/tmi/Tmi.js